var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body" }, [
    _c("div", { staticClass: "close-btn", on: { click: _vm.close } }, [
      _c(
        "i",
        { staticClass: "material-icons md-18", attrs: { title: "close" } },
        [_vm._v("close")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "title" }, [_vm._v("SAVE PARCEL TO")]),
    _vm._v(" "),
    _vm.token === null
      ? _c(
          "div",
          {
            staticClass: "lock-block lock-block-sharp",
            on: { click: _vm.routeLogin }
          },
          [_vm._m(0), _vm._v(" "), _vm._m(1)]
        )
      : _c(
          "ul",
          { staticClass: "list" },
          [
            _vm._l(_vm.collections, function(row, index) {
              return _vm.collections
                ? _c(
                    "li",
                    {
                      key: row.id,
                      staticClass: "interactive",
                      on: {
                        click: function($event) {
                          return _vm.toggleParcelToCollection(row)
                        }
                      }
                    },
                    [
                      _vm.isSavedLoading(row)
                        ? _c("span", { staticClass: "loader" })
                        : _vm.isSavedInCollection(row)
                        ? _c("i", { staticClass: "material-icons md-18" }, [
                            _vm._v("bookmark")
                          ])
                        : _c("i", { staticClass: "material-icons md-18" }, [
                            _vm._v("bookmark_border")
                          ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(row.name))])
                    ]
                  )
                : _c("li", { staticClass: "interactive" }, [
                    _c("i", { staticClass: "material-icons md-18" }, [
                      _vm._v("bookmark_border")
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Favorites")])
                  ])
            }),
            _vm._v(" "),
            _vm.mode === "add"
              ? _c("li", { staticClass: "position-relative" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.addCollection.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c(
                        "i",
                        {
                          staticClass: "material-icons md-18 cursor-pointer",
                          on: { click: _vm.hideAddForm }
                        },
                        [_vm._v("close")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "popup-row-form input-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.string",
                              value: _vm.addCollectionName,
                              expression: "addCollectionName",
                              modifiers: { string: true }
                            }
                          ],
                          staticClass: "form-control form-control-sm",
                          attrs: {
                            type: "text",
                            placeholder: "New collection name"
                          },
                          domProps: { value: _vm.addCollectionName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.addCollectionName = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(2)
                      ])
                    ]
                  )
                ])
              : _c(
                  "li",
                  {
                    staticClass: "interactive",
                    on: { click: _vm.showAddForm }
                  },
                  [
                    _c("i", { staticClass: "material-icons md-18" }, [
                      _vm._v("add")
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Add Collection")])
                  ]
                )
          ],
          2
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lock-icon-box" }, [
      _c("i", { staticClass: "material-icons md-36" }, [_vm._v("account_box")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lock-text" }, [
      _c("h5", { staticClass: "mb-0 text-white" }, [
        _vm._v("Sign in to save to collections")
      ]),
      _vm._v(" "),
      _c("h5", { staticClass: "mb-0 font-weight-light text-light" }, [
        _vm._v("Store this parcel in an organized list")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c(
        "button",
        { staticClass: "btn btn-dark btn-sm", attrs: { type: "submit" } },
        [_vm._v("Save")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f3dcf6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f3dcf6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parcel/parcel-save.vue
// module id = null
// module chunks = 